import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/components/layout/app-header';

export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col w-full">
      <AppHeader />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
    </div>
  );
}
